import axiosInstance from './AxiosInstance';
import { getApiUrl } from '../utils/ApiUtils';

export async function leaveCompany(userId, companyId) {
    const url = getApiUrl(`users/${userId}/companies/${companyId}`);
    const response = await axiosInstance.delete(url);
    return response.data;
}
